/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Panel } from 'react-bootstrap';
import PieChart from 'loracoms/PieChart';
import IntlMsg from 'lorautils/intl/IntlMsg';

const propTypes = {
  intl: intlShape.isRequired,
  status: PropTypes.string.isRequired,
  nodeStatus: PropTypes.object.isRequired,
};

class LinksPie extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: props.status,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.node');
  }

  componentWillReceiveProps({ status, nodeStatus }) {
    if (status !== this.props.status) {
      this.setState({ status });
    }
    if (!_.isEqual(nodeStatus, this.props.nodeStatus)) {
      this.initSeries(nodeStatus);
    }
  }

  initSeries(nodeStatus) {
    if (!nodeStatus.counters) return;
    const { tdmup, alohaup } = nodeStatus.counters || {};
    const series = [{
      name: this.intlMsg.msg('status.tdmup'),
      value: tdmup,
      itemStyle: {
        normal: {
          color: '#59abe3',
        },
      },
      label: {
        normal: {
          position: 'inside',
        },
      },
      labelLine: {
        normal: {
          length: 5,
          length2: 5,
        },
      },
    }, {
      name: this.intlMsg.msg('status.alohaup'),
      value: alohaup,
      itemStyle: {
        normal: {
          color: '#f4b350',
        },
      },
      label: {
        normal: {
          position: 'inside',
        },
      },
    }];
    this.setState({ series });
  }

  render() {
    const {
      series = [],
    } = this.state;
    return (
      <Panel
        bsStyle="aisz-white" header={this.intlMsg.msg('pie.header')}
      >
        <PieChart
          series={[{
            label: {
              normal: {
                formatter: '{b}\n{d}%',
              },
              emphasis: {
                formatter: '{b}\n{d}%',
              },
            },
            data: series,
          }]}
        />
      </Panel>
    );
  }
}

LinksPie.propTypes = propTypes;

export default injectIntl(LinksPie);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/NodeStatus/LinksPie.jsx